import React, { useState } from "react";
import {/*  Layout, */ Form,Input,Tabs ,Button,notification} from "antd";
import Logo from "../../../assets/img/png/logo512-blanco.png";
import Letras from "../../../assets/img/png/letras-white.png";
import { post } from "../../../api/post";

import i18n from "../../../i18n";
import {useLanguage} from "../../../hooks"

import "./ResetPass.scss";

export default function ResetPass() {
  //const { Content } = Layout;
  const { TabPane } = Tabs;
  
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    idp: "",
  });
  const [circular, setcircular] = useState(false);
  const{language,setLanguage,isEs,setIsEs}=useLanguage();

  const changeForm = (e) => {
    // console.log(e)
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });

   
  };

  const onChangeLanguage=()=>{
    i18n.changeLanguage(language);
    if(language==='es'){
      setIsEs(false);
      setLanguage('en');
    } else{
      setIsEs(true);
      setLanguage('es');
    }
  }

  const login = async (e) => {
    setcircular(true)
    const result = await post(inputs,'send-recovery-email','send-recovery-email','');

    try {
      if (result.message) {
        notification["success"]({
          message: 'Correo enviado',
        });
        localStorage.setItem('EMAIL', inputs.email);
        window.location.href = "/opt";
        setcircular(false)
      } else {
        notification["success"]({
          message: "Correo enviado",
        });
        localStorage.setItem('EMAIL', inputs.email);
        window.location.href = "/opt";
        setcircular(false)
      }
    } catch (error) {
      notification["success"]({
        message: 'Correo enviado',
      });
      // window.location.href = "/admin/login";
      setcircular(false)
    }
  };

  return (
    <div className="sign-in">
      <div className="background">
        <div className="background-pictureAndLogo">
        <h1 className="background-pictureAndLogo-letras">
            <img src={Letras} alt="letras" />
          </h1>
          <a href='/' className="background-pictureAndLogo-logo">
            <img src={Logo} alt="logo" />
          </a>
        </div>
        <div className="background-content">
          <div className="background-content-tabss">
          <div 
            style={{marginBottom: '5px', color: 'rgb(35,148,212)', fontFamily: 'report', textDecoration: 'underline',fontSize:'24px'}}>
            Recuperar contraseña
          </div>
          <div 
            style={{marginBottom: '7px', color: 'black' ,fontSize:'15px',width:'250px',textAlign:'center'}}>
            Te enviarémos un correo con las instrucciones para el cambio de contraseña. Recuerda revisar la carpeta de Spam.
          </div>
            {/* <Tabs type="card">
              <TabPane tab={<span >Recuperar contraseña</span>} key="1"> */}
              <Form className="login-form" onChange={changeForm} onFinish={login}>
                <Form.Item>
                    <Input
                      //prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                      type="email"
                      name="email"
                      placeholder="Correo electronico"
                      className="login-form__input"
                    />
                  </Form.Item>
                  <Form.Item>
                    {(circular)?<Button disabled={true}  style={{
                                backgroundColor:'rgb(220,220,220)',
                                borderWidth:'2px',
                                fontSize:'22px',
                                borderColor:'grey',
                                color:'grey',
                                fontFamily:'report'
                              }} type="primary" htmlType="submit" className="login-form__button">
                      Enviar correo
                    </Button>
                    :<Button type="primary" style={{
                      color:'rgb(35,148,212)',
                      fontFamily:'report',
                      backgroundColor:'rgb(211, 232, 245)',
                      borderWidth:'2px',
                      fontSize:'22px',
                      borderColor:'rgb(35,148,212)',
                    }} htmlType="submit" className="login-form__button">
                      Enviar correo
                    </Button>}
                    {(circular)
                    ?<div className="holas" style={{display:'flex', justifyContent:'center'}}>
                      <div className="cargandoOutput">
                      
                      </div>
                      <div className="" style={{paddingLeft:'20px',paddingTop:'10px'}}>
                      <h3 >Enviando correo</h3>
                      
                      </div>
                    </div>
                  :<div className="vacioOutput">
                    </div>}
                  </Form.Item>
                </Form>
              {/* </TabPane>
            </Tabs> */}
          </div>
        </div>
      </div>
    </div>
  );
}
